import { createFileRoute } from '@tanstack/react-router';

import { LoginLayout } from '@/_containers';

export const Route = createFileRoute('/_public')({
  component: LoginLayout,
});
